<div class="empty-state-container">
  <h3>Le tableau est vide</h3>
  <p>
    Aucun acte &nbsp;
    <span class="empty-state-container-orange-word">archivé</span> &nbsp; à
    afficher pour le moment.
  </p>
</div>
